import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import getRescheduleTypeList from 'Api/reschedule/getRescheduleTypeList';
import getRescheduleTypeListResponse from './model/response/getRescheduleTypeListResponse';
import getRescheduleTypeListRequest from './model/request/getRequestApprovalTypeRequest';

const useGetRescheduleTypeList = () => {
  const { id } = useParams();

  return useQuery({
    queryKey: ['reschedule-type-list'],
    queryFn: async () => {
      const queries = getRescheduleTypeListRequest(id);

      const response = await getRescheduleTypeList(queries);

      const result = getRescheduleTypeListResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetRescheduleTypeList;
